import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "@angular/common";
import * as i3 from "@angular/forms";
function AccountNewsSourceSettingsComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 2)(1, "input", 3);
    i0.ɵɵtwoWayListener("ngModelChange", function AccountNewsSourceSettingsComponent_label_1_Template_input_ngModelChange_1_listener($event) { const source_r2 = i0.ɵɵrestoreView(_r1).$implicit; i0.ɵɵtwoWayBindingSet(source_r2.active, $event) || (source_r2.active = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("click", function AccountNewsSourceSettingsComponent_label_1_Template_input_click_1_listener() { const source_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateActiveState(source_r2.active, source_r2.internalName)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 4);
    i0.ɵɵelementStart(3, "span", 5);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const source_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", source_r2.active);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(source_r2.label);
} }
export class AccountNewsSourceSettingsComponent {
    constructor(accountsService) {
        this.accountsService = accountsService;
        this.VALID_SOURCES = [
            {
                internalName: 'mt_newswires',
                label: 'MT Newswires',
                active: false,
            },
            {
                internalName: 'press_releases',
                label: 'Press Releases',
                active: false,
            },
            {
                internalName: 'yahoo',
                label: 'Yahoo',
                active: false,
            },
            {
                internalName: 'sa_breaking_news',
                label: 'SA Breaking News',
                active: false,
            },
        ];
        this.activeSources = [];
    }
    ngOnInit() {
        this.accountsService.getUserPreferences().subscribe((preference) => {
            this.activeSources = preference.news_sources;
            for (let i = 0; i < this.VALID_SOURCES.length; i += 1) {
                if (this.activeSources.includes(this.VALID_SOURCES[i].internalName)) {
                    this.VALID_SOURCES[i].active = true;
                }
            }
        });
    }
    updateActiveState(active, sourceName) {
        const newActiveSources = [];
        if (active) {
            // Remove source
            for (let i = 0; i < this.activeSources.length; i += 1) {
                if (this.activeSources[i] !== sourceName) {
                    newActiveSources.push(this.activeSources[i]);
                }
            }
        }
        else {
            for (let i = 0; i < this.activeSources.length; i += 1) {
                newActiveSources.push(this.activeSources[i]);
            }
            // Add source
            newActiveSources.push(sourceName);
        }
        this.accountsService.putUserPreferences({ news_sources: newActiveSources }).subscribe();
    }
}
AccountNewsSourceSettingsComponent.ɵfac = function AccountNewsSourceSettingsComponent_Factory(t) { return new (t || AccountNewsSourceSettingsComponent)(i0.ɵɵdirectiveInject(i1.AccountsService)); };
AccountNewsSourceSettingsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AccountNewsSourceSettingsComponent, selectors: [["ycn-news-source-settings"]], decls: 2, vars: 1, consts: [[1, "custom-controls-stacked"], ["class", "custom-control custom-checkbox", 4, "ngFor", "ngForOf"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "ngModelChange", "click", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description"]], template: function AccountNewsSourceSettingsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, AccountNewsSourceSettingsComponent_label_1_Template, 5, 2, "label", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.VALID_SOURCES);
    } }, dependencies: [i2.NgForOf, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.NgModel], encapsulation: 2 });
